import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Sticky } from 'react-sticky';
import requiredIf from 'react-required-if';
import styles from './styles.module.styl';
import RequiredUserResourcesTooltip from './RequiredUserResourcesTooltip';
import BetaBadge from '../../BetaBadge';

const StickyHeader = ({
  showSampleButtons,
  isAuthenticated,
  requiredResources,
  title,
  showDownloadModal,
  githubSampleLink,
  trackViewGithubSample,
  handleLogin,
  beta
}) => (
  <Sticky topOffset={200} disableCompensation>
    {({ isSticky }) => (
      <div className={cx(styles.stickyHeader, { [styles.isSticky]: isSticky })}>
        <div className={cx(styles.container, 'container')}>
          <h3 className={styles.title}>{title} {beta && <BetaBadge />}</h3>
          { showSampleButtons &&
            <div className={styles.buttons}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={githubSampleLink}
                onClick={trackViewGithubSample}
                className={`${styles.btn} btn btn-transparent`}
              >
                View on Github
              </a>
              {isAuthenticated ?
                <RequiredUserResourcesTooltip requiredResources={requiredResources}>
                  <button
                    disabled={!!requiredResources}
                    onClick={showDownloadModal}
                    className={`${styles.btn} btn btn-success`}
                  >
                    Download Sample
                  </button>
                </RequiredUserResourcesTooltip> :
                <button
                  onClick={handleLogin}
                  className={`${styles.btn} btn btn-success`}
                >
                  Log In & Download Sample
                </button>
              }
            </div>
          }
        </div>
      </div>
    )}
  </Sticky>);

StickyHeader.propTypes = {
  showSampleButtons: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  requiredResources: requiredIf(
    PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.bool
    ]),
    props => props.showSampleButtons
  ),
  title: PropTypes.string.isRequired,
  showDownloadModal: PropTypes.func.isRequired,
  githubSampleLink: requiredIf(PropTypes.string, props => props.showSampleButtons),
  trackViewGithubSample: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired,
  beta: PropTypes.bool.isRequired
};

export default StickyHeader;
